// extracted by css-extract-rspack-plugin
export default {"CollectionLink":"o9lF0"};